import { CircleUser, Home, Briefcase, GraduationCap } from "lucide-react";

/**
 * Centralised workspace identity. Each workspace has its own brand colour and
 * iconography so users always know exactly which workspace they're in.
 */
export const WORKSPACES = {
  personal: {
    key: "personal",
    label: "Personal",
    fullLabel: "Personal Dashboard",
    color: "#0281FF",
    colorRgb: "2, 129, 255",
    mood: "Calm, clean, focused",
    icon: CircleUser,
    description: "Your private workspace — habits, errands, side projects.",
  },
  family: {
    key: "family",
    label: "Family",
    fullLabel: "Family Dashboard",
    color: "#F97522",
    colorRgb: "249, 117, 34",
    mood: "Warm, connected, energetic",
    icon: Home,
    description: "Shared family tasks, plans, and reminders.",
  },
  work: {
    key: "work",
    label: "Work",
    fullLabel: "Work Dashboard",
    color: "#842DDA",
    colorRgb: "132, 45, 218",
    mood: "Professional, productive, premium",
    icon: Briefcase,
    description: "Professional tasks, meetings, and deliverables.",
  },
  school: {
    key: "school",
    label: "School",
    fullLabel: "School Dashboard",
    color: "#1CBF62",
    colorRgb: "28, 191, 98",
    mood: "Focused, ambitious, growing",
    icon: GraduationCap,
    description: "Courses, certifications, exams, study sessions & training.",
    /** Suggested chip tags surfaced in the School dashboard empty state. */
    defaultCategories: [
      "Courses",
      "Certifications",
      "Exams",
      "Homework",
      "Reading",
      "Research",
      "Projects",
      "Workshops",
      "Training",
      "Notes",
    ],
  },
};

export function getWorkspace(key) {
  return WORKSPACES[key] || WORKSPACES.personal;
}

/** True if a given pathname is inside one of the workspaces. */
export function workspaceFromPath(pathname = "") {
  if (pathname.startsWith("/family") && !pathname.startsWith("/family-workspace"))
    return "family";
  if (pathname.startsWith("/work")) return "work";
  if (pathname.startsWith("/school")) return "school";
  if (pathname.startsWith("/personal")) return "personal";
  return null;
}
